import { AbgabebelegPosition } from '../../../../projects/kiene-core/src/lib/components/abgabebelege/classes/abgabebeleg-position';

/** Wie master: keine Stücklisten-Kopf- und Unterpositionen im Inline-Editor. API-Zahlen oft als Strings. */
export function istAbgabebelegPositionInlineLadbar(pos: AbgabebelegPosition | null | undefined): boolean {
    return (Number(pos?.stueckliste) || 0) === 0 && (Number(pos?.aus_stueckliste) || 0) === 0;
}

export function istAbgabebelegChargenArtikel(pos: AbgabebelegPosition | null | undefined): boolean {
    return (Number(pos?.chargeJN) || 0) === 1;
}

export function abgabebelegAaId(pos: { aa_id?: unknown } | null | undefined): number {
    return Number(pos?.aa_id) || 0;
}

export function hatAbgabebelegAaId(pos: { aa_id?: unknown } | null | undefined): boolean {
    return abgabebelegAaId(pos) > 0;
}

export function abgabebelegAaIdEquals(a: unknown, b: unknown): boolean {
    return abgabebelegAaId({ aa_id: a }) === abgabebelegAaId({ aa_id: b });
}

export function abgabebelegIdEquals(a: unknown, b: unknown): boolean {
    if (a == null && b == null) {
        return true;
    }
    if (a == null || b == null) {
        return false;
    }
    return Number(a) === Number(b);
}

export function istAbgabebelegImpfung(pos: { impfung?: unknown } | null | undefined): boolean {
    return (Number(pos?.impfung) || 0) === 1;
}

export function istAbgabebelegMengenartikel(pos: { mengenartikel?: unknown } | null | undefined): boolean {
    return (Number(pos?.mengenartikel) || 0) === 1;
}

export function istAbgabebelegBehandlung(pos: { behandlung?: unknown } | null | undefined): boolean {
    return (Number(pos?.behandlung) || 0) === 1;
}

export function hatAbgabebelegIndikation(pos: { indikation_id?: unknown } | null | undefined): boolean {
    return (Number(pos?.indikation_id) || 0) > 0;
}

/** Chargen beim Speichern erhalten, wenn das Inline-Formular sie nicht (mehr) enthält. */
export function mergeAbgabebelegPositionChargen(
    target: AbgabebelegPosition | null | undefined,
    source: AbgabebelegPosition | null | undefined,
): void {
    if (!target || !istAbgabebelegChargenArtikel(target) || target.chargen?.length) {
        return;
    }
    if (source?.chargen?.length) {
        target.chargen = source.chargen;
    }
}
